<template>
  <b-modal
    id="pendencia"
    title="Pendência de Vistoria"
    size="lg"
    variant="dark"
    :visible="showModalPendencia"
    :hide-footer="true"
    @hide="hideModal"
  >
    <div v-if="seguro && seguro.lstPendencia && seguro.lstPendencia.length > 0">
      <b-alert
        show
        variant="secondary"
        class="mb-3"
        v-for="(item, index) in seguro.lstPendencia"
        :key="index"
      >
        <div><b>Passo:</b> {{ item.passo }}</div>
        <div>
          <b>Problemas:</b>
          <b-badge
            v-for="(pendencia, indexp) in item.lstProblemas"
            :key="indexp"
            variant="success  "
            class="ml-1 mb-1"
          >
          {{ pendencia }}
          </b-badge>
          
        </div>
        <div><b>Observação:</b> {{ item.observacao }}</div>
      </b-alert>
    </div>
    <div v-else-if="seguro">
      <p>Não há pendências de vistoria para este seguro.</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["seguro", "showModalPendencia"],
  components: {},
  watch: {},
  methods: {
    hideModal(arg, data) {
      this.$emit("hide", data || { modificou: false });
    },
  },
};
</script>
